import React, { PropTypes } from 'react';
import localize from '../../../localize';
import { getCurrentLanguage } from '../../../localData';
import CSSModules from 'react-css-modules';
import styles from './no-records-found.scss';

const NoRecordsFound = () => (
    <li styleName="text">
            <span styleName="text-inner">
                { localize(`${getCurrentLanguage()}.components.NoRecordsFound.text`) }
            </span>
    </li>
);

export default CSSModules(NoRecordsFound, styles);


// WEBPACK FOOTER //
// ./app/components/shared/NoRecordsFound/index.jsx